import Modal from "react-bootstrap/Modal";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import SrvButton from "../global/SrvButton";

function ModalAdd({ show, onHide, updateHandler, loading, error, title }) {

    const [name, setName] = useState(null);
    const [log, setLog] = useState(null);

    useEffect(() => {
        if (show === true) {
            setName(null);
            setLog(null);
        }

    }, [show]);

    useEffect(() => {
        setLog(error);
    }, [error]);

    function update() {
        if (name == null || name == '' || name == undefined) {
            setLog('Введите название');
        }
        else {
            updateHandler(name);
        }
    }

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Body >
                <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                <div className="modal_title text-center">{title}</div>
                <div className="mt-15">
                    <input type="text" className="form-control" disabled={loading} placeholder="Введите название..." onChange={(e) => setName(e.target.value)} />
                </div>
                <div className="text_error text-center">{log}</div>
                <div className="row">
                    <div className="col-md-12 text-center">
                        <SrvButton typeBtn="add" size='lg' loading={loading} onClick={() => update()} />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}
export default ModalAdd;
